<div class="action-button"
     [matMenuTriggerFor]="BulkValidateMenu">
  <div class="iconContainer">
    @if (!detailsLoading()) {
      <mat-icon [class]="styleModel().iconClass"
                [svgIcon]="styleModel().iconName"/>
    } @else {
      <mat-spinner [diameter]="24"></mat-spinner>
    }
  </div>
  <div class="label-small"
       [class]="styleModel().iconClass">(In)Validate
  </div>
</div>


<mat-menu #BulkValidateMenu="matMenu">
  <div class="flex flex-col w-[360px]
              p-6"
       (click)="$event.stopPropagation()">

    <span class="label pb-1">Listing data sync</span>
    <div class="flex flex-row">
      <mat-icon [class]="styleModel().iconClass"
                [svgIcon]="styleModel().iconName"/>
      <span [class]="'pl-2 title ' +
                        styleModel().iconClass">{{
          bulkValidationDetails()?.status ?
              (('ADDRESS_LIST.BULK_VALIDATION.' + bulkValidationDetails().status) | translate)
              : 'n/a'
        }}</span>
    </div>

    <mat-progress-bar mode="determinate"
                      [value]="bulkValidationDetails()?.percentage ? bulkValidationDetails().percentage : 0"
                      [class]="'py-1 ' + styleModel().progressBarClass"/>

    <div class="flex flex-row w-full justify-between body-large pb-6">
      <span>{{ elapsedTime() }}</span>
      <span>{{
          (bulkValidationDetails()?.percentage ? bulkValidationDetails().percentage : 0)
          + '% done'
        }}</span>
    </div>

    <div class="flex flex-row pb-6 gap-x-4">
      <div class="flex flex-col w-1/2">
        <span class="label">Start time</span>
        <span class="body-large">{{
            bulkValidationDetails()?.startTime ?
                (bulkValidationDetails().startTime | date:'dd.MM.yyyy, HH:mm') : 'n/a'
          }}</span>
      </div>

      <div class="flex flex-col w-1/2">
          <span
              class="label">Last (in)validation</span>
        <span class="body-large">{{
            bulkValidationDetails()?.endTime ?
                (bulkValidationDetails().endTime | date:'dd.MM.yyyy, HH:mm') : 'n/a'
          }}</span>
      </div>
    </div>

    <button mat-icon-button
            (click)="getDetails()"
            class="text-neutral-30 loadDetailsButton"
            matTooltip="Refresh"
            [disabled]="detailsLoading()">
      <mat-icon svgIcon="refresh" [ngClass]="{ loading: detailsLoading() }"></mat-icon>
    </button>

    <mat-divider class="my-6"/>

    @if (!selectedLocationIds().length) {
      <span class="body-large mb-6">Select locations to validate or invalidate</span>
    }

    <span class="pb-1 label">Action</span>
    <mat-button-toggle-group class="mb-6"
                             [disabled]="!selectedLocationIds().length"
                             [(ngModel)]="action">
      <mat-button-toggle class="w-full" value="VALIDATE">Validate</mat-button-toggle>
      <mat-button-toggle class="w-full" value="INVALIDATE">Invalidate</mat-button-toggle>
    </mat-button-toggle-group>

    @if (action() === 'INVALIDATE') {
      <div class="flex p-4 mb-6 items-start gap-x-2 self-stretch rounded-[16px] bg-orange-80">
        <mat-icon class="min-w-6" svgIcon="report_problem_outline"/>
        <span class="body-medium">This action will invalidate coordinates for all selected locations. Proceed with caution.</span>
      </div>
    } @else {
      <span class="pb-1 label">Coordinates to validate</span>
      <mat-button-toggle-group class="mb-6"
                               [disabled]="!selectedLocationIds().length"
                               [(ngModel)]="pinSource">
        <mat-button-toggle class="w-full" value="IMPORT">Imported</mat-button-toggle>
        <mat-button-toggle class="w-full" value="GEOCODE">Geocoded</mat-button-toggle>
      </mat-button-toggle-group>
    }

    <button (click)="validate()"
            class="self-end"
            mat-flat-button
            [disabled]="validateButtonDisabled()">
      {{ action() | capitalizeFirstLetter }}

      @if (bulkValidateLoading()) {
        <mat-progress-bar class="restartButtonLoadingBar"
                          mode="indeterminate"/>
      }
    </button>

  </div>
</mat-menu>




